import type { ReactNode } from "react";
import { cx } from "./cx.js";

export type Tone = "neutral" | "ok" | "warn" | "alarm" | "bad" | "info";

const VALUE_TONE: Record<Tone, string> = {
  neutral: "text-ink",
  ok: "text-ink",
  warn: "text-warn",
  alarm: "text-alarm",
  bad: "text-bad",
  info: "text-ink",
};

/** One number with its label. Only an abnormal tone colours the value; a healthy figure stays ink. */
export function StatTile({
  label,
  value,
  hint,
  tone = "neutral",
  trend,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: Tone;
  trend?: ReactNode;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1 rounded-lg border border-line bg-surface p-4 shadow-card">
      <span className="text-xs font-medium tracking-[0.04em] text-ink-muted">{label}</span>
      <div className="flex items-end justify-between gap-3">
        <span className={cx("font-mono text-[28px] font-semibold leading-9 tabular-nums", VALUE_TONE[tone])}>
          {value}
        </span>
        {trend}
      </div>
      {hint ? <span className="text-xs text-ink-muted">{hint}</span> : null}
    </div>
  );
}
